import { render, staticRenderFns } from "./CompanyIncorporationApplications.vue?vue&type=template&id=2bea83e1&scoped=true&"
import script from "./CompanyIncorporationApplications.vue?vue&type=script&lang=js&"
export * from "./CompanyIncorporationApplications.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIncorporationApplications.vue?vue&type=style&index=0&id=2bea83e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bea83e1",
  null
  
)

export default component.exports